import type { ProgressStatus } from '../types';

interface Props {
  value: ProgressStatus;
  onChange: (status: ProgressStatus) => void;
  size?: 'sm' | 'md';
}

const OPTIONS: { value: ProgressStatus; label: string }[] = [
  { value: 'new', label: 'New' },
  { value: 'practiced', label: 'Practiced' },
  { value: 'learned', label: 'Learned' },
];

export function StatusControl({ value, onChange, size = 'md' }: Props) {
  return (
    <div className={`segmented ${size}`} role="group" aria-label="Practice status">
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={`seg ${opt.value} ${value === opt.value ? 'active' : ''}`}
          aria-pressed={value === opt.value}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
